import {connect} from 'react-redux';
import {form, utils, authActions} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {LoginForm} = form;
import {Link} from 'react-router-dom';
const {storeFromArea} = utils;
import {Card, CardBody, Col, Container, Row} from "reactstrap";
import Title from "../components/Title";
import {Redirect, withRouter} from "react-router";
import './LoginPage.scss';
import {withTranslation, WithTranslation} from "react-i18next";

class LoginPage extends Component<WithTranslation> {

    render() {
        const {authInfo, t} = this.props;

        if (authInfo.data && authInfo.data.auth) {
            let url = "/";
            if (this.props.location.state && this.props.location.state.from) {
                url = this.props.location.state.from;
            }
            return <Redirect to={url} />
        }

        return <Title title={t('pages.login.title')}>
            <div className="login-page">
                <Container>
                    <Card className={"inverse login-page-content"}>
                        <CardBody>
                            <div className={"w-100 text-center mt-4 mb-4"}>
                                <img src={serverContextPath + "/favicon.svg"} className={"logo"} alt={t('app_logo')} />
                                <h2>{window.APP_TITLE || "PlanOnline"}</h2>
                            </div>
                            <LoginForm/>
                        </CardBody>
                        <Link to={"/password-reset-request"} className={"ml-3 mb-1"}>
                            {t('forgotten_password')}
                        </Link>
                    </Card>
                </Container>
            </div>
        </Title>
    }
}

export default withRouter(connect((state, props) => ({authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA)}))(withTranslation()(LoginPage)));
